import { EmployerAgreementSourcesService_employerAgreementSourcesServiceGetLatestSourceStop } from '@festina/life-general-types/life/hooks/EmployerAgreementSourcesStopsService_employerAgreementSourcesServiceGetLatestSourceStop'

export const useFetchEmployerAgreementSourcesStopsLatest =
  EmployerAgreementSourcesService_employerAgreementSourcesServiceGetLatestSourceStop.useSuspenseQuery
